<template>
  <div class="impressum-page">
    <page-cover :cover="cover" v-if="cover" />
    <Impressum />
  </div>
</template>

<script>
import PageCover from "@/components/shared/PageCover.vue";
import Impressum from "@/components/impressum/Impressum.vue";
import { mapGetters } from "vuex";

export default {
  name: "impressum",
  computed: {
    ...mapGetters({
      cover: "pageCover/getImpressum", // <-- using the new getter
    }),
  },
  components: {
    PageCover,
    Impressum,
  },
};
</script>